import React, { useEffect } from "react";
import { KeyRound, Copy } from "lucide-react";
import { toast } from "sonner";
import { usePartner } from "@/context/PartnerContext";
import { useCopy } from "@/lib/copy";

// Partner shops show their own public key here; the main site keeps its static /pgp-key.html.
export default function PgpKey() {
  const { partner, brand, isPartner, ready } = usePartner();
  const { t, C } = useCopy();
  const key = partner?.pgp_public_key;

  useEffect(() => {
    if (ready && !isPartner) window.location.replace("/pgp-key.html");
  }, [ready, isPartner]);

  if (!isPartner) return null;
  if (!key) {
    return (
      <div className="mx-auto max-w-3xl px-6 py-16" data-testid="pgp-key-missing">
        <h1 className="font-heading text-3xl font-black tracking-tight">{t("pgp_page_missing_title")}</h1>
        <p className="mt-3 text-sm text-muted-foreground"><C k="pgp_page_missing_body" /></p>
      </div>
    );
  }
  const copy = () => { navigator.clipboard?.writeText(key); toast.success("Public key copied"); };
  return (
    <div className="mx-auto max-w-3xl px-6 py-16" data-testid="pgp-key-page">
      <div className="mono text-[11px] uppercase tracking-[0.25em] text-primary">Encrypt your delivery details</div>
      <h1 className="mt-2 flex items-center gap-3 font-heading text-3xl font-black tracking-tight"><KeyRound className="h-6 w-6 text-primary" /> {brand.name} PGP public key</h1>
      {partner.pgp_fingerprint && (
        <p className="mt-4 text-sm text-muted-foreground">{t("pgp_page_fingerprint")}
          <span className="mt-1 block select-all font-mono text-sm font-semibold tracking-wide text-primary" data-testid="pgp-key-fingerprint">{partner.pgp_fingerprint}</span>
        </p>
      )}
      <button data-testid="pgp-key-copy" onClick={copy} className="mt-6 inline-flex items-center gap-2 bg-primary px-5 py-2.5 text-xs font-medium text-primary-foreground">
        <Copy className="h-3.5 w-3.5" /> Copy public key
      </button>
      <pre data-testid="pgp-key-block" className="mt-4 select-all overflow-x-auto border border-border bg-card p-4 font-mono text-[11px] leading-relaxed">{key}</pre>
    </div>
  );
}
